import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom"
import styles from './StaticFieldManager.module.css'

// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'

// ------ Components ------ //
import StaticField from '../../../components/Badging/StaticFieldManager/StaticField'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'

// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

// image elements
const circleCheck = <FontAwesomeIcon icon={faCircleCheck} />
const circleXmark = <FontAwesomeIcon icon={faCircleXmark} />

const StaticFieldManager = () => {

    // State
    const [extraBadgeFields, setExtraBadgeFields] = useState([])
    const [extraBadgesTable, setExtraBadgesTable] = useState([]) // compiled object of all badges for save process
    const [dataValidationObj, setDataValidationObj] = useState([])
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(false)
    const [saveBody, setSaveBody] = useState({})
    const [loaded, setLoaded] = useState(false)

    const [clientEventInfo, setClientEventInfo] = useState({})
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "ClientId": `${clientEventInfo.clientId}`,
                "EventId": `${clientEventInfo.eventId}`
            }
        }

        // Set future save request body
        setSaveBody({
            ...saveBody,
            ...requestBody
        })

        return await requestBody;
    }

    const updateCompiledObject = (index, updatedObj) => {
        setExtraBadgesTable(prevState => {
            const newState = [...prevState]
            newState[index] = updatedObj
            return newState
        })
    }

    const updateDataValidationObject = (index, updatedObj) => {
        setDataValidationObj(prevState => {
            const newState = [...prevState]
            newState[index] = updatedObj
            return newState
        })
    }

    const handleContinueButtonVisiblity = () => {
        dataValidationObj.includes(false)
            ? setContinueButtonVisibility(false)
            : setContinueButtonVisibility(true)
    }

    const handleSave = async e => {
        e.preventDefault()
        const staticTemplateHolder = []

        // Have to iterate over extraBadgesTable length to save each badge
        for (let i = 0; i < extraBadgeFields.length; i++) {

            const staticTemplate = await buildSaveObject(i)

            //console.log("individual object", staticTemplate)
            staticTemplateHolder.push(staticTemplate)
        }

        const fullSaveObject = {
            ...saveBody,
            StaticTemplates: staticTemplateHolder
        }

       // console.log(JSON.stringify(fullSaveObject))
        await badgeService.saveExtraBadgesStaticFields(fullSaveObject)
    }
    const handleSaveAndNavigate = async e => {
        e.preventDefault()
        
        await handleSave()
        navigate(`/ExtraBadgeTemplateStyling`, { state: { clientEventInfo } })
    }

    const buildSaveObject = i => {
        const entries = Object.entries(extraBadgesTable[i])

        let extraBadgeSmallsObj = {
            CSSExtraBadgesField: extraBadgeFields[i].cssExtraBadgesField,
            CSSExtraBadgesFieldName: extraBadgeFields[i].cssExtraBadgesFieldName,
            StaticFields: entries.map(([key, values]) => ({
                FieldValueSelected: key,
                TextValues: values
            }))
        }

       // console.log(extraBadgeSmallsObj)
        return extraBadgeSmallsObj
    }

    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName) {
            const fetchData = async () => {
                const getReqBody = await createRequestBody()
                const EEBFs = await badgeService.getExtraBadgesStaticFields(getReqBody)
                //console.log(EEBFs)
                // Reset compiled save/validation state so a client/event switch can't leak
                // stale rows into the next save.
                setExtraBadgesTable([])
                setDataValidationObj([])
                setContinueButtonVisibility(false)
                setExtraBadgeFields(EEBFs)
                setLoaded(true)
            }
            fetchData()
        }
    }, [clientEventInfo])

    useEffect(() => {
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
        }
    }, [])
    useEffect(() => {
        if (dataValidationObj.length) handleContinueButtonVisiblity()
    }, [dataValidationObj])

    
    return (
        <div id={styles.EBFPage}>
            <h1>Static Field Manager</h1>

            {loaded ?
                <>
                    <br /> <br />
                    <BackSaveContinueButton
                        continueButtonVisibility={continueButtonVisibility}
                        handleSaveAndNavigate={handleSaveAndNavigate}
                        handleSave={handleSave}
                        styles={styles}
                        navigate={navigate}
                    />
                    <br />
                    {continueButtonVisibility ?
                        <> </>
                        :
                        <p id={styles.invalidDataHeader}>
                            Please provide values for <b>Badge Text for Selection</b> for each available selection
                        </p>
                    }

                    <div id={styles.extraBadgeContainer}>
                        {extraBadgeFields.length ?
                            <div id={styles.regTypeTableSection}>
                                <table id={styles.regTypeTable}>
                                    <thead>
                                        <tr id={styles.tableHeading}>
                                            <th className={styles.tableHeaders}>
                                                Badge Name
                                                <HoverButton
                                                    title={'Values from ERS'}
                                                    messageWidth={200}
                                                />
                                            </th>
                                            <th className={styles.tableHeaders}>
                                                Available Selections
                                                <HoverButton
                                                    title={'Dropdown with available selections'}
                                                    messageWidth={200}
                                                />
                                            </th>
                                            <th className={styles.tableHeaders}>
                                                Badge Text for Selection
                                                <HoverButton
                                                    title={'Text to display on the extra badge for chosen selection'}
                                                    messageWidth={200}
                                                />
                                            </th>
                                            <th>
                                                <i className={styles.buttonImage} id={styles.validIconHeader}>
                                                    {circleCheck}
                                                </i>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {extraBadgeFields.map((item, index) => (
                                            <StaticField
                                                key={`${clientEventInfo.eventId}-${item.cssExtraBadgesField ?? index}`}
                                                index={index}
                                                item={item}
                                                updateCompiledObject={updateCompiledObject}
                                                updateDataValidationObject={updateDataValidationObject}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div>
                                <h2>No Extra Badges Selected - Please Select from Mapping page</h2>
                                <Link to="/BadgeToERSPropertyMapping"
                                    state={clientEventInfo}
                                >
                                    <h3>Go to Mapping Page</h3>
                                </Link>
                            </div>
                        }
                    </div>
                    <br /> <br />
                    <BackSaveContinueButton
                        continueButtonVisibility={continueButtonVisibility}
                        handleSaveAndNavigate={handleSaveAndNavigate}
                        handleSave={handleSave}
                        styles={styles}
                        navigate={navigate}
                    />
                    <br />
                </>
            :
                <LoadingSpinner/>
            }
        </div>
    );
}

export default StaticFieldManager;